import React, { useState, useContext } from "react";
import { useHistory } from 'react-router-dom';

import loadingGif from "../../../static/loading.gif";
import { ArrowNarrowLeftIcon } from "@heroicons/react/solid";

import { viewImgContext } from "..";

const SlideList = () => {
  const { slides, isShowSlidesLoading, seleChange, slideId } = useContext(viewImgContext);
  const history = useHistory();
  
  if(isShowSlidesLoading) {
    return (
      <div className="w-full h-full flex justify-center items-center">
        <img alt='' src={loadingGif} className='w-12 h-12' />
      </div>
    )
  };

  return (
    <div className="SlideList w-full overflow-y-scroll h-full scrollbar-hide">
      <h3 className="flex text-sm font-medium py-2" onClick={
        () => {
          history.goBack()
        }
      }> <ArrowNarrowLeftIcon className="w-4 mr-1"></ArrowNarrowLeftIcon>Back</h3>
        <div className="w-full overflow-y-scroll h-full scrollbar-hide">
        {
          slides.map((item, index) => (
            <div className={`w-9/12 m-auto h-24 border-2 mr-6 mb-6 rounded-md cursor-pointer relative ${slideId === item.ID ? 'border-blue-500 selected': ''}`}
              key={index}
              onClick={() => {seleChange(item)}}
            >
              <div className='w-full h-full overflow-hidden img-scale-box'>
                <img className='w-full h-full img-scale' alt='' src={`${item?.Dzi?.replace('.dzi', '_files/8/0_0.jpeg')}`} />
              </div>
              <div style={{"background": "rgba(0,0,0,.4)"}} className='w-full text-white text-xs font-serif absolute bottom-0'>{item.SlideName || "default_name.png"}</div>
            </div>
          ))
        }
        </div>
    </div>
  )
};

export default SlideList